import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Ratesprocuredownload} from '../frt-rates-download/ratesprocuredownload';

@Injectable()
export class HhgRateDownloadService {
  constructor(private http: HttpClient) {
  }

  private baseURI = '/tmssserver/api/public';

  /**
   *
   * @param: ratesPoc
   * @param: pagenumber
   * @param: pageSize
   */
  getRowDataWithPage(ratesPoc: Ratesprocuredownload, pagenumber: number, pageSize: number): any {
    return this.http.post('/tmssserver/api' + '/hhgrates/searchHhgRates' + '?page=' + pagenumber + '&size=' + pageSize , ratesPoc);
  }

  /**
   *
   * @param: carrierId
   * @param: paramsObj
   */
    exportDataFromServer(ratesPoc: Ratesprocuredownload): any {
    return this.http.post('/tmssserver/api' + '/hhgrates/searchHhgRates/csv/', ratesPoc);
  }

}

